import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgForOf, NgIf } from '../../../node_modules/@angular/common';
import { Publication } from '../data/models/publication.model';
import { PublicationImage } from '../data/models/publicationImage.model';
import { RecipeStep } from '../data/models/recipe-step.model';
import { PublicationService } from '../data/services/publication.service';

@Component({
  selector: 'app-publication',
  standalone: true,
  imports: [NgForOf, NgIf],
  templateUrl: './publication.component.html',
  styleUrl: './publication.component.scss',
})
export class PublicationComponent {
  id = '';
  publication: Publication = {
    chef: undefined,
    commentCount: 0,
    content: '',
    createdAt: '',
    id: 0,
    images: [],
    likeCount: 0,
    mainImageId: 0,
    mainImageUrl: '',
    origin: '',
    recipe: undefined,
    recipeId: 0,
    title: '',
    user: undefined,
  };
  publicationSteps: RecipeStep[] = [];

  constructor(
    private route: ActivatedRoute,
    private publicationService: PublicationService,
  ) {
    this.route.paramMap.subscribe((params) => {
      this.id = params.get('id') ?? '';
    });
  }

  ngOnInit(): void {
    this.publicationService.getPublicationDetails(this.id).subscribe({
      next: (data) => {
        this.publication = data;
        let mainImage: PublicationImage = {
          url: this.publication.mainImageUrl,
        };
        this.publication.images?.unshift(mainImage);
      },
      error: (error) => {
        console.error(error);
      },
    });
    setTimeout(() => {
      document.getElementById('slide0')?.click();
    }, 1000);
  }
}
